<template>
  <div id="generator">
    <div class="tile is-ancestor">
      <div class="tile is-parent is-6">
        <div class="tile is-child box container">
          <div class="has-text-centered">
            <b-tooltip
              class="title is-4"
              label="生成するテキストの引用元を選択してください。"
              position="is-bottom"
              dashed
              multilined
            >引用元</b-tooltip>
          </div>
          <p class="blank1em"></p>
          <div class="field">
            <b-radio v-model="textName" name="name" native-value="Lorem">Lorem Ipsum</b-radio>
          </div>
          <div class="field">
            <b-radio v-model="textName" name="name" native-value="Kokoro">こころ</b-radio>
          </div>
          <div class="field">
            <b-radio v-model="textName" name="name" native-value="Galaxy">銀河鉄道の夜</b-radio>
          </div>
          <div class="field">
            <b-radio v-model="textName" name="name" native-value="Wikipedia">Wikipedia</b-radio>
          </div>
          <!-- <p class="radioValue">
            <b>選択した元ネタ:</b>
            {{ textName }}
          </p> -->
        </div>
      </div>
      <div class="tile is-parent is-6">
        <div class="tile is-child box">
          <div class="has-text-centered">
            <b-tooltip
              class="title is-4"
              label="生成したい文字数を入力、またはスライドバーで選択してください。"
              position="is-bottom"
              dashed
              multilined
            >出力する文字数</b-tooltip>
          </div>
          <p class="blank2em"></p>
          <b-field>
            <b-numberinput v-model="textNumber" rounded controls-rounded :min="1" :max="500"></b-numberinput>
          </b-field>

          <b-field>
            <b-slider v-model="textNumber" :min="1" :max="500"></b-slider>
          </b-field>
          <!-- <p class="numberValue">
            <b>文字数:</b>
            {{ textNumber }}
          </p> -->
        </div>
      </div>
    </div>
    <div class="tile is-ancestor">
      <div class="tile is-parent is-6">
        <div class="tile is-child box">
          <div class="has-text-centered">
            <b-tooltip
              class="title is-4"
              label="出力する際の条件を設定してください。"
              position="is-bottom"
              dashed
              multilined
            >出力オプション</b-tooltip>
          </div>
          <p class="blank1em"></p>
          <div class="field">
            <b-checkbox v-model="selecedOptions" native-value="needBreak">文章ごとに改行する</b-checkbox>
          </div>
          <div class="field">
            <b-checkbox v-model="selecedOptions" native-value="makeWide">英数字は全角にする</b-checkbox>
          </div>
          <div class="field">
            <b-checkbox v-model="selecedOptions" native-value="endWithPeriod">句点まで生成する</b-checkbox>
          </div>
          <div class="field">
            <b-checkbox v-model="selecedOptions" native-value="addPtag">文章ごとにPタグを付与する</b-checkbox>
          </div>
          <!-- <p class="content">
            <b>Selection:</b>
            {{ selecedOptions }}
          </p> -->
        </div>
      </div>
      <div class="tile is-parent is-6">
        <div class="tile is-child box">
          <div class="has-text-centered">
            <b-tooltip
              class="title is-4"
              label="テキストを生成してクリップボードへコピーします。"
              position="is-bottom"
              dashed
              multilined
            >テキスト生成</b-tooltip>
          </div>
          <p class="blank5em"></p>
          <div class="has-text-centered">
            <gen-text
              v-bind:quote-textname="textName"
              v-bind:output-number="textNumber"
              v-bind:gen-options="selecedOptions"
              button-msg="テキストを生成する"
              button-icon="clipboard-text"
            ></gen-text>
          </div>
        </div>
      </div>
    </div>
    <p class="blank1em"></p>
  </div>
</template>

<script>
import genText from "./generate.vue";

export default {
  components: {
    genText
  },
  data: function() {
    return {
      textName: "Lorem",
      textNumber: 200,
      selecedOptions: []
    };
  }
};
</script>

<style scoped>
#generator {
  margin: auto;
  max-width: 800px;
}
</style>